import queryString from 'query-string';
import { v4 as uuidv4 } from 'uuid';
import { IMAGE_TYPE } from '@meitu/saas-editor-core/es/utils/file-kit';

export const getBase64ByObjectUrl = async (url: string) => {
    return await fetch(url)
        .then((r) => r.blob())
        .then((blobFile) => new File([blobFile], `ss${uuidv4()}`, { type: blobFile.type }));
};

/**
 * 生成图片
 *
 * @param base64  - 图片 Base64 编码
 * @param width - 图片的宽度
 * @param height - 图片高度
 */
export const createImage = (base64: string, width: number, height: number) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.src = base64;
        img.width = width;
        img.height = height;
        img.onload = function () {
            resolve(img);
        };
        img.onerror = (error) => {
            reject(error);
        };
    });
};

export const formatImageUrl = (url: string) => {
    if (!url) return url;
    const [originUrl] = url.split('!');
    return originUrl;
};

/**
 * 获取图片信息（宽高等）
 *
 * @param url - 图片连接
 */
export const getImageInfo = async (url: string) => {
    return new Promise<{ width: number; height: number }>((resolve, reject) => {
        try {
            const image = new Image();
            image.src = url;
            image.onload = function () {
                resolve({ width: image.width, height: image.height });
            };
            image.onerror = (error) => {
                reject(error);
            };
        } catch (error) {
            reject(error);
        }
    });
};

export const imageToBase64 = (url: string): Promise<string> => {
    return new Promise((resolve, reject) => {
        try {
            const canvas = document.createElement('canvas');
            const image = new Image();

            image.setAttribute('crossOrigin', 'Anonymous');
            image.src = url;

            image.onload = function () {
                const width = image.width;
                const height = image.height;

                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context?.drawImage(image, 0, 0, width, height);
                resolve(canvas.toDataURL('image/png'));
            };
            image.onerror = (error) => {
                reject(error);
            };
        } catch (error) {
            reject(error);
        }
    });
};

export const base64ToBlob = (base64Data: string) => {
    const arr = base64Data.split(',');
    const fileType = arr[0]?.match(/:(.*?);/);
    if (!fileType) return;
    const bstr = atob(arr[1]);
    let l = bstr.length;
    const u8Arr = new Uint8Array(l);

    while (l--) {
        u8Arr[l] = bstr.charCodeAt(l);
    }
    return new Blob([u8Arr], {
        type: fileType[1],
    });
};

export const pickFiles = async (accept = IMAGE_TYPE.join(','), multiple = false) => {
    return new Promise<FileList | null>((resolve) => {
        const $input = document.createElement('input');

        $input.style.display = 'none';
        $input.type = 'file';
        $input.accept = accept;
        $input.multiple = multiple;

        document.body.appendChild($input);

        $input.click();
        $input.onchange = (e) => {
            const target = e.target as HTMLInputElement;

            if (target && target.files) {
                document.body.removeChild($input);
                resolve(target.files);
            }
        };

        $input.oncancel = (e) => {
            const target = e.target as HTMLInputElement;
            if (target) {
                document.body.removeChild($input);
                resolve(null);
            }
        };
    });
};

type TransferImageToLongType = { data?: { data?: { url?: string } } };
/**
 * 加签图片的转存操作
 *
 * @param url - 图片链接地址
 */
export const signatureRemove = async (
    url: string,
    transferImageToLong: (url: string) => Promise<TransferImageToLongType>,
) => {
    if (!url) return url;
    try {
        const params = queryString.parseUrl(url);
        if (params.query.k && params.query.t) {
            url = (await transferImageToLong(url))?.data?.data?.url ?? url;
        }
    } catch (error) {
        console.log(error);
    }
    return url;
};

/**
 * 处理图片错误
 *
 * @param event - 事件
 */
export const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.style.display = 'none';
};
